import React from "react";

const GooglePlusIcon = props => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>google-plus</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g
      id="google-plus"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="iconmonstr-google-plus-1"
        transform="translate(0.000000, 5.000000)"
        fill="#363636"
        fillRule="nonzero"
      >
        <path
          d="M7,6 L7,8.4 L10.97,8.4 C10.81,9.429 9.77,11.42 7,11.42 C4.61,11.42 2.66,9.441 2.66,7 C2.66,4.56 4.61,2.58 7,2.58 C8.36,2.58 9.27,3.16 9.79,3.66 L11.69,1.83 C10.47,0.69 8.89,1.77635684e-15 7,1.77635684e-15 C3.13,1.77635684e-15 -8.8817842e-16,3.13 -8.8817842e-16,7 C-8.8817842e-16,10.87 3.13,14 7,14 C11.04,14 13.721,11.16 13.721,7.16 C13.721,6.7 13.67,6.35 13.61,6 L7,6 Z M7,6 L24,8 L21,8 L21,11 L19,11 L19,8 L16,8 L16,6 L19,6 L19,3 L21,3 L21,6 L24,6 L24,8 L7,6 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

export default GooglePlusIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/GooglePlusIcon.js